import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private _profile: ProfileService, private _router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let webSocketVal = false;
    let webSocketCode = '';
    let webSocketId = '';

    const availableRoutes = ['finishOperation', 'finishProOperation'];
    const availableSocketsRoutes = ['webSocketOperation', 'webSocketProOperation'];

    let url = state.url.split('/');

    if (!this._profile.getToken() && !availableRoutes.includes(url[2])) {
      this._router.navigate(['login'], { queryParams: { returnUrl: state.url } });
      return false;
    } else if (!this._profile.getToken() && url[1] == 'u' && availableRoutes.includes(url[2])) {
      let socketUrl: string;
      url.forEach((element) => {
        if (element.includes(availableSocketsRoutes[0]) || element.includes(availableSocketsRoutes[1])) {
          webSocketVal = true;
          webSocketCode = element;
          webSocketId = webSocketCode.split('=')[1];
        }
      });
      if (webSocketVal) {
        if (webSocketCode.includes('webSocketProOperation')) {
          socketUrl = 'webSocketProOperation';
          this._router.navigate([url[2], url[3], url[4], url[5], socketUrl], {
            queryParams: { id: webSocketId },
          });
        } else {
          socketUrl = 'webSocketOperation';
          this._router.navigate([url[2], url[3], socketUrl], {
            queryParams: { id: webSocketId },
          });
        }
      } else {
        this._router.navigate([url[2], url[3]]);
      }
    } else if (this._profile.getToken() && url[1] == '' && availableRoutes.includes(url[2])) {
      this._router.navigate(['u', url[2], url[3]]);
    }
    document.body.classList.remove('is-public');

    return true;
  }
}
